export default __webpack_public_path__ + "static/media/package_1_selected.f739cf13.png";